import styled from "styled-components";
import { AccountLinkButtonText } from "./buttonText";
import type { AccountLinkProps } from "./interface";
import { NavLink } from "./navLink";
import { generateLinks } from "./linkHelper";
import { useSystemStore } from "@dealer-center/ddc-state-system";

const StyledAccountNameArea = styled.div`
  display: flex;
  width: 100%;
  button {
    margin-right: 4px;
  }
`;
const StyledLinksArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  width: 100%;
  button {
    margin-right: 4px;
  }
`;
const StyledAccountLink = styled.span`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  width: 100%;
`;
export const AccountLink = ({
  accountID,
  sameWindow,
  component,
  accountName,
  isLoadingAccountName,
  testId,
  className
}: AccountLinkProps) => {
  const { enviroment } = useSystemStore();

  const links = generateLinks(accountID, enviroment === "prod", sameWindow);
  const htmlSafeAccountId = accountID.replace(/[^a-zA-Z0-9]/g, "");

  return (
    <StyledAccountLink
      className={className}
      data-testid={`${testId}account-link-${htmlSafeAccountId}`}
    >
      <StyledAccountNameArea>
        <AccountLinkButtonText
          accountID={accountID}
          accountName={accountName}
          isLoadingAccountName={isLoadingAccountName}
          testId={`${testId}account-link-controlcenter-${htmlSafeAccountId}-account-name`}
        />
      </StyledAccountNameArea>
      <StyledLinksArea>
        {links.map(link => (
          <NavLink
            accountID={accountID}
            component={component}
            key={link.label}
            label={link.label}
            sameWindow={link.sameWindow}
            testId={testId}
            url={link.url}
          />
        ))}
      </StyledLinksArea>
    </StyledAccountLink>
  );
};
